import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../auth/authStore";
import ClientTodayDashboardV3 from "../components/dashboard/ClientTodayDashboardV3";
import StaffTodayDashboardV3 from "../components/dashboard/StaffTodayDashboardV3";

const PSY_DASHBOARD_ROLES = new Set(["PSYCHOLOGIST", "PSYCHO", "ADMIN", "SUPER_ADMIN", "MODERATOR"]);

export default function Dashboard() {
  const { booting, role } = useAuth();

  if (booting) return null;

  const normalizedRole = String(role || "")
    .replace(/^ROLE_/, "")
    .trim()
    .toUpperCase();

  if (normalizedRole === "CLIENT") {
    return <ClientTodayDashboardV3 />;
  }

  if (PSY_DASHBOARD_ROLES.has(normalizedRole)) {
    return <StaffTodayDashboardV3 />;
  }

  return <Navigate to="/login" replace />;
}
